<template>
  <DeviceDetail :is-edit="true"/>
</template>

<script>
import DeviceDetail from './detail';

export default {
  name: "DeviceEdit",
  components: { DeviceDetail },
}
</script>

<style scoped>

</style>
